export default __webpack_public_path__ + "static/media/check.c6597016.svg";